import ServiceBase from "base/baseService"

export default class PisCstService extends ServiceBase {

    title = "CST do PIS"
    pluralTitle = "CSTs do PIS"
    url = '/cadastro/fiscal/piscst'
    frontUrl = '/cadastro/fiscal/piscst'
    frontUrlList = '/cadastro/fiscal/piscstlist'
    primaryKey = 'codigo_piscst'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Se usar Switch (Se não permite null?)

        // Se usar checkbox (Se permite null?)

        // Numéricos com FK notNullable

        // Strings notNullable

        data.codigo_piscst = data?.codigo_piscst || ''
        data.descricao_piscst = data?.descricao_piscst || ''
        data.cod_tiflu_piscst = data?.cod_tiflu_piscst || ''

        // Numéricos sem FK

        // Dependentes

        // Datas

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
